import $ from 'jquery';

export default function() {
    if(typeof $.fn.tooltip === 'function') {
        $(this).find('[data-tooltip-placements]').each(function () {
            const $container = $(this);
            const placement = $container.attr('data-tooltip-placements');
            $container.find('[data-toggle="tooltip"]').each(function () {
                $(this).attr('data-placement', placement);
            });
        });
        $(this).tooltip({selector: '[data-toggle="tooltip"]'});
    }
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/tooltip.js